var map = {
	"./_layout": 16413,
	"./_layout.tsx": 16413,
	"./event_call-2603-l": 59731,
	"./event_call-2603-l.tsx": 59731,
	"./event_candy-250324-l": 12163,
	"./event_candy-250324-l.tsx": 12163,
	"./event_draw-2608-l": 25655,
	"./event_draw-2608-l.tsx": 25655,
	"./event_fall-2610-l": 59575,
	"./event_fall-2610-l.tsx": 59575,
	"./event_luckydraw-250626-l": 63783,
	"./event_luckydraw-250626-l.tsx": 63783,
	"./event_npay-2509-l": 91684,
	"./event_npay-2509-l.tsx": 91684,
	"./event_summer-2607-l": 99655,
	"./event_summer-2607-l.tsx": 99655,
	"./main_consulting": 47660,
	"./main_consulting.tsx": 47660,
	"./main_ina": 93650,
	"./main_ina.tsx": 93650,
	"./main_pet": 72073,
	"./main_pet.tsx": 72073,
	"./main_settlement": 19101,
	"./main_settlement.tsx": 19101
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	if(!__webpack_require__.m[id]) {
		var e = new Error("Module '" + req + "' ('" + id + "') is not available (weak dependency)");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
webpackContext.id = 71884;
module.exports = webpackContext;